import router from './router'
import store from '@/store'
import util from '@/libs/util'
import config from '@/config'
import ViewUI from 'view-design'
import Cookies from 'js-cookie'

const whiteList = ['/login', '/password']

let flag = 0
router.beforeEach(async(to, from, next) => {
    ViewUI.LoadingBar.start()
    let name = to.name
    if (to.meta.hasOwnProperty('title')) {
      name = to.meta.title
    }
    util.title(config.title + ' - ' + name)
    const hasToken = Cookies.get('jwt')
    if (hasToken) {
      // 处理cas跳转
       let redirect = to.query.redirect;
       if (!redirect) {
         redirect = '/home';
       }
       if (redirect.startsWith('http')) {
         const cas = await store.dispatch('getCasTicket')
         window.location.href = redirect + '?ticket=' + cas.data
         return
       }
       if (flag === 0) {
          // 获取菜单
          store.dispatch('getMyk8s')
          const accessRoutes = await store.dispatch('permission/generateRoutes')
          // dynamically add accessible routes
          router.addRoutes(accessRoutes)
          flag++
          if (whiteList.indexOf(to.path) > -1) {
            next(redirect)
          }
          // 处理login已登录
          next({...to, replace: true})
        } else {
          if (whiteList.indexOf(to.path) > -1) {
            next(redirect)
          }
          next()
        }
    } else {
      if (whiteList.indexOf(to.path) !== -1) {
        next()
      } else {
        // next(false)
        next(`/login?redirect=${to.path}`)
      }
    }
})

router.afterEach(() => {
    ViewUI.LoadingBar.finish()
    window.scrollTo(0, 0)
})

export default router



// WEBPACK FOOTER //
// ./src/permission.js